import { render, staticRenderFns } from "./Datagraph1.vue?vue&type=template&id=4e00678e&scoped=true"
import script from "./Datagraph1.vue?vue&type=script&lang=js"
export * from "./Datagraph1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e00678e",
  null
  
)

export default component.exports